class VwHastarapordetayDTO {
    id: number = 0;
    hastaraporId?: number = null;
    raportiptanimverigirisId?: number = null;
    rapor?: string = "";
    adi?: string = "";
    edityontem?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    raporStr?: string = null;
}
export default VwHastarapordetayDTO;